import apiClient from '@/services/axios'

export async function put(invitationId) {
  var response = await apiClient.put('/teamMembers/invites/' + invitationId)
  if (response) {
    return response.data
  }

  throw new Error('Unable to accept Invitiation.')
}
